import { format } from "date-fns";

type Props = {
  date: Date;
};

export default function Time({ date }: Props) {
  return <span>{format(date, "HH:mm")} &#8226;</span>;
}
